/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_EvaluationInputs */

const en_svchip_evaluation = /** @type {(inputs: Svchip_EvaluationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evaluation`)
};

const ar_svchip_evaluation = /** @type {(inputs: Svchip_EvaluationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التقييم`)
};

const bn_svchip_evaluation = /** @type {(inputs: Svchip_EvaluationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ইভ্যালুয়েশন`)
};

const de_svchip_evaluation = /** @type {(inputs: Svchip_EvaluationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auswertung`)
};

const es_svchip_evaluation = /** @type {(inputs: Svchip_EvaluationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evaluación`)
};

const fr_svchip_evaluation = /** @type {(inputs: Svchip_EvaluationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Évaluation`)
};

const pt_svchip_evaluation = /** @type {(inputs: Svchip_EvaluationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avaliação`)
};

const zh_svchip_evaluation = /** @type {(inputs: Svchip_EvaluationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`评估`)
};

const tr_svchip_evaluation = /** @type {(inputs: Svchip_EvaluationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değerlendirme`)
};

const ru_svchip_evaluation = /** @type {(inputs: Svchip_EvaluationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оценка`)
};

const pl_svchip_evaluation = /** @type {(inputs: Svchip_EvaluationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocena`)
};

/**
* | output |
* | --- |
* | "Evaluation" |
*
* @param {Svchip_EvaluationInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_evaluation = /** @type {((inputs?: Svchip_EvaluationInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_EvaluationInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_evaluation(inputs)
	if (locale === "bn") return bn_svchip_evaluation(inputs)
	if (locale === "de") return de_svchip_evaluation(inputs)
	if (locale === "es") return es_svchip_evaluation(inputs)
	if (locale === "fr") return fr_svchip_evaluation(inputs)
	if (locale === "pt") return pt_svchip_evaluation(inputs)
	if (locale === "zh") return zh_svchip_evaluation(inputs)
	if (locale === "tr") return tr_svchip_evaluation(inputs)
	if (locale === "ru") return ru_svchip_evaluation(inputs)
	if (locale === "pl") return pl_svchip_evaluation(inputs)
	return en_svchip_evaluation(inputs)
});